require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-einmusik-spektrum.json") })
        }
      }, "path---feature-einmusik-spektrum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-einmusik-spektrum!./.cache/json/feature-einmusik-spektrum.json
// module id = 638
// module chunks = 231608221292675